import script from "./ConfigurationView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfigurationView.vue?vue&type=script&lang=ts&setup=true"

import "./ConfigurationView.vue?vue&type=style&index=0&id=5c212032&lang=scss"

const __exports__ = script;

export default __exports__